import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { END_URL, IMG_URL } from "../../config";
import Dashboard from "../Dashboard/Dashboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFilePdf,faTrash } from "@fortawesome/free-solid-svg-icons";
import "../DeepDrive/DeepDrive.css";
import gg from "../../../src/images/pp-logo.gif"

function ZoomMetting({ globaltest }) {

  const navigate = useNavigate();
  const [attempts, setAttempts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [BannerContent, setBannerContent] = useState({});

  const [deletingId, setDeletingId] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedAttemptId, setSelectedAttemptId] = useState(null);

  useEffect(() => {

    const fetchAttempts = async () => {

      const token = localStorage.getItem("token");
      if (!token) {

        console.error("User not authenticated");
        navigate("/login");
        return;
      }

      try {
        
        const response = await axios.get(`${END_URL}/zoom/history`, {

          headers: { Authorization: `Bearer ${token}` },
        });

        setAttempts(response?.data?.bookingHistory || []);

        setBannerContent(response?.data?.banner_content || {});
        setLoading(false);
      } catch (error) {
        console.error("Error fetching attempts:", error);
        setLoading(false);
      }
    };

    fetchAttempts();

    window.scrollTo(0, 0);

  }, [navigate]);

    const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-"); 
    return `${day}-${month}-${year}`;
    };


  const handleViewAttempt = (attemptId) => {
    navigate(`/view-attempt/${attemptId}`);
  };

    const handlepdf = async (item_id,pdf_url) => {

      const token = localStorage.getItem("token");

      try {
          await axios.post(

            `${END_URL}/update/zoom/${item_id}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          window.open(pdf_url, "_blank");

        } catch (error) {
          
          console.error("Failed to update notification", error);
          
          window.open(pdf_url, "_blank");
        }

    };

    const handleRemoveClick = (attemptId) => {
    setSelectedAttemptId(attemptId);
    setShowConfirm(true);
  };

  const confirmRemove = async () => {
    if (!selectedAttemptId) return;

    const token = localStorage.getItem("token");

    setDeletingId(selectedAttemptId);

    try {
      await axios.delete(`${END_URL}/zoom/history/${selectedAttemptId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setAttempts((prev) => prev.filter((attempt) => attempt.id !== selectedAttemptId));

    } catch (error) {

   
    } finally {

      setDeletingId(null);
      setShowConfirm(false);
      setSelectedAttemptId(null);
    }
  };

  const cancelRemove = () => {
    setShowConfirm(false);
    setSelectedAttemptId(null);
  };

  

  return (
    <div className="deep-main past-result-main">
      
      <div className="container-fluid deep-fluid past-result-cont">
     
      {loading ? (

          
          <div className="loadingDiv">
                         <img
                      src={gg}
                      alt="Loading..."

                    />
            </div>

        ) : (

        <div className="row deep-sec-row">

          <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">

            <Dashboard globaltest={globaltest} />

          </div>

          <div className="col-12 col-sm-12 col-md-8">

            <div className="deep-inner-outer past-result">

              <h3 style={{ marginBottom: "20px" }}>{BannerContent?.zoom_history_title}</h3>

              {loading ? (

                  <div className="asm-card-bx2">
   
                        </div>
                
              ) : attempts.length === 0 ? (

                <div className="alert alert-warning">
                  No past attempts found. Take the test to see your history here.
                </div>
              ) : (

                <div className="attempts-list">
                  <table className="table table-striped">
                    <thead>
                      <tr>

                        <th></th>

                        <th>{BannerContent?.zoom_table_col_1}</th>
         
                        <th>{BannerContent?.zoom_table_col_2}</th>

                        <th>{BannerContent?.zoom_table_col_3}</th>

                        <th>{BannerContent?.zoom_table_col_4}</th>

                        <th>{BannerContent?.zoom_table_col_5}</th>

                        <th>{BannerContent?.zoom_table_col_6}</th>

                      </tr>
                    </thead>
                    <tbody>
                      {attempts.map((attempt, index) => (
                        <tr key={attempt.id}>
                          <td>{index + 1}</td>

                          <td>{formatDate(attempt.date)}</td>
                     
                            <td>
                                {attempt.starttime} - {attempt?.endtime}
                            </td>

                            {attempt?.is_expired ? ( 

                                <td>Expired</td>
                            ):(

                               <td>  
                                      {attempt?.status === "approved"
                                      ? attempt.status.toUpperCase()
                                      : attempt.status.charAt(0).toUpperCase() + attempt.status.slice(1)
}
                                </td>
                            )}

                          <td>

                             {attempt?.is_expired ? ( 

                                'Link Expired'

                             ):(

                                attempt?.zoom_meeting_link ? attempt?.zoom_meeting_link : 'No Meeting Links'
                             )}

                          </td>

                          <td>
                                {attempt.pdfcollection && !attempt?.is_expired && (

                                    <button
                                    className="btn btn-danger btn-sm" 
                                    onClick={() => handlepdf(attempt?.id,`${IMG_URL}/d0/zoom-back/${attempt?.id}/${attempt?.pdfcollection}`)}
                                    >
                                    <FontAwesomeIcon icon={faFilePdf} /> {BannerContent?.zoom_feed_back_btn}
                                    </button>
                                )}
                          </td>

                          <td>

                             <button
                                className="btn btn-danger btn-sm"
                                onClick={() => handleRemoveClick(attempt.id)}
                                disabled={deletingId === attempt.id}
                              >
                                {deletingId === attempt.id ? (
                                  <>
                                    <span className="spinner-border spinner-border-sm me-2" />
                                    Removing...
                                  </>
                                ) : (
                                  <>
                                    <FontAwesomeIcon icon={faTrash} /> Remove
                                  </>
                                )}
                              </button>

                          </td>

                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
        )}


      </div>

        {showConfirm && (
          <div className="modal fade show d-block zoom-remove-links" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{BannerContent?.zoom_delete_comform}</h5>
                  <button type="button" className="btn-close" onClick={cancelRemove}></button>
                </div>
                <div className="modal-body" dangerouslySetInnerHTML={{ __html:BannerContent?.zoom_delete_comform_content }}/>
                  
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={cancelRemove}>
                    Cancel
                  </button>
                  <button type="button" className="btn btn-danger" onClick={confirmRemove}>
                    {deletingId ? "Removing..." : "Yes, Remove"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}



    </div>
  );
}

export default ZoomMetting;